// extracted by mini-css-extract-plugin
export default {"wrapper":"W_PaymentActions_wrapper__yfIqv"};